import { api } from './http';

export type SenderStatsPeriod = 'day' | 'week' | 'month' | 'year' | 'all';
export type SenderStatsTopDimension = 'domain' | 'template' | 'link';

export interface ISenderStatsFunnelStep {
	key: string;
	label: string;
	count: number;
}

export interface ISenderStatsFunnelResponse {
	period: SenderStatsPeriod;
	funnel: ISenderStatsFunnelStep[];
	totals: { connect: number; download: number };
	telegramAuth: {
		totals: {
			starts: number;
			codeAttempts: number;
			passwordAttempts: number;
			sessions: number;
		};
	};
}

export interface ISenderStatsTopItem {
	id: string;
	label: string;
	connect: number;
	sessions: number;
}

export interface ISenderStatsTopResponse {
	period: SenderStatsPeriod;
	dimension: SenderStatsTopDimension;
	items: ISenderStatsTopItem[];
}

export async function fetchSenderStatsFunnel(period: SenderStatsPeriod) {
	const { data } = await api.get<ISenderStatsFunnelResponse>('/sender/stats/funnel', {
		params: { period },
	});
	return data;
}

export async function fetchSenderStatsTop(period: SenderStatsPeriod, dimension: SenderStatsTopDimension) {
	const { data } = await api.get<ISenderStatsTopResponse>('/sender/stats/top', {
		params: { period, dimension },
	});
	return data;
}
